import apiClient from './client';
import { leaderboardApiUrl } from '../utils/runtime';

export async function fetchLeaderboard(params = {}) {
  const baseUrl = leaderboardApiUrl || '/wp-json/pfandpirat/v1/leaderboard';
  const search = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }
    search.set(key, String(value));
  });

  const url = search.toString() ? `${baseUrl}?${search.toString()}` : baseUrl;
  const data = await apiClient.get(url);

  return {
    board: data?.board || 'xp',
    scope: data?.scope || 'global',
    period: data?.period || 'all',
    report_status: data?.report_status || 'valid',
    view: data?.view || 'top',
    city: data?.city || '',
    cities: Array.isArray(data?.cities) ? data.cities : [],
    crew_id: Number(data?.crew_id || 0),
    generated_at: data?.generated_at || '',
    total_ranked_users: Number(data?.total_ranked_users || 0),
    my_rank: data?.my_rank != null ? Number(data.my_rank) : null,
    my_user_id: Number(data?.my_user_id || 0),
    my_entry: data?.my_entry || null,
    summary: data?.summary || null,
    estimate_note: data?.estimate_note || '',
    estimate_values: data?.estimate_values || null,
    items: Array.isArray(data?.items) ? data.items : [],
  };
}

export default fetchLeaderboard;
